module.exports = {
    currentDate() {
        return window.__wmicServerDate ? new Date(window.__wmicServerDate) : new Date();
    }
}
